import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { CharacterTypeSectionState, Resource, Workbook } from 'types';
import { getNewLink } from 'util/workbook-util';
import CharacterList from './CharacterList';
import { remCalc } from '../../util/style-util';
import { translate } from 'translations/translator';
const translateApps = key => translate('apps', key);

type Props = {
  application: string;
  items: CharacterTypeSectionState[];
  locale: string;
  styleOverrides?: any;
  onClickItem: (character: Resource) => void;
  currentWorkbook: Workbook;
} & any;

const CharacterSelector = (props: Props) => {
  const { items, onClickItem, styleOverrides, application, currentWorkbook } = props;

  const [selectedGroup, setSelectedGroup] = useState(props?.items?.[0]);

  useEffect(() => {
    if (!props?.items?.[0]) return;
    setSelectedGroup(props?.items?.[0]);
  }, [props?.items?.[0]]);

  const onGroupClick = (newGroup: CharacterTypeSectionState) => {
    setSelectedGroup(newGroup);
  };

  const { groups, selectedGroupStyle, unselectedGroup } = useStyles();
  return (
    <div>
      <Link to={getNewLink(currentWorkbook.bookCode, currentWorkbook.edition, 'lnf')}>
        <div className={application === 'LNF' ? selectedGroupStyle : unselectedGroup}>
          {translateApps('letterFormation')}
        </div>
      </Link>
      <Link to={getNewLink(currentWorkbook.bookCode, currentWorkbook.edition, 'wdt')}>
        <div className={application === 'WDT' ? selectedGroupStyle : unselectedGroup}>
          {translateApps('wdt')}
        </div>
      </Link>
      <Link to={getNewLink(currentWorkbook.bookCode, currentWorkbook.edition, 'wp')}>
        <div className={application === 'WoodPieces' ? selectedGroupStyle : unselectedGroup}>
          {translateApps('woodPieces')}
        </div>
      </Link>

      {items.length > 1 ? (
        <div className={groups}>
          {items.map((group, index) => {
            return (
              <div
                className={
                  selectedGroup && selectedGroup.grouping === group.grouping
                    ? selectedGroupStyle
                    : unselectedGroup
                }
                key={index}
                onClick={() => onGroupClick(group)}
              >
                {group.grouping}
              </div>
            );
          })}
        </div>
      ) : null}
      <br />
      <br />
      {selectedGroup ? (
        <CharacterList
          characters={selectedGroup.characters}
          onClickItem={onClickItem}
          styleOverrides={styleOverrides}
          characterGroup={selectedGroup.grouping}
          application={application}
        />
      ) : items.length !== 0 ? (
        <CharacterList
          characters={items[0].characters}
          onClickItem={onClickItem}
          styleOverrides={styleOverrides}
          characterGroup={items[0].grouping}
          application={application}
        />
      ) : (
        <div />
      )}
    </div>
  );
};

const useStyles = makeStyles(() => ({
  groups: {
    float: 'right',
    right: remCalc(50)
  },
  selectedGroupStyle: {
    backgroundColor: '#1d1d1f',
    color: 'yellow',
    display: 'inline-block',
    textAlign: 'center',
    padding: '5px 8px',
    borderRadius: '5px',
    marginLeft: remCalc(15),
    fontSize: remCalc(13),
    cursor: 'pointer'
  },
  unselectedGroup: {
    backgroundImage: 'linear-gradient(#4e4e51, #28272b)',
    color: 'white',
    display: 'inline-block',
    textAlign: 'center',
    padding: '5px 8px',
    borderRadius: '5px',
    boxShadow: '0 0 10px #343034',
    marginLeft: remCalc(15),
    fontSize: remCalc(13),
    cursor: 'pointer'
  }
}));

export default CharacterSelector;
